// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g5tG","content":"styles_content__3CxU_"};